// Custom Field (UI validation & display; single source of truth for this feature)
export const CUSTOM_FIELD_KEY_PREFIX = "cl_custom_";
export const CUSTOM_FIELD_NAME_MAX_LENGTH = 40;
export const CUSTOM_FIELD_USER_KEY_MAX_LENGTH = 60;
export const CUSTOM_FIELD_DESCRIPTION_MAX_LENGTH = 500;
export const CUSTOM_FIELD_KEY_MAX_LENGTH =
  CUSTOM_FIELD_KEY_PREFIX.length + CUSTOM_FIELD_USER_KEY_MAX_LENGTH;

// Single select options.
/**
 * One lifetime budget per custom field, counting active and archived options
 * together. Options are never hard-deleted, so an archived one keeps its slot.
 *
 * There is deliberately no second "active" counter: an earlier draft of the
 * spec capped active options at 50, and that rule was withdrawn.
 */
export const CUSTOM_FIELD_OPTION_LIMIT_PER_FIELD = 200;
/**
 * These come from the PRD, not from the API contract, which names an
 * `invalid_option_name` error without stating a bound. Asked of the CDH owner;
 * adjust if the server enforces something else, or the counter shown in the
 * input will disagree with the server's verdict.
 *
 * Counted in code points (see `countOptionCharacters`), not UTF-16 code units.
 */
export const CUSTOM_FIELD_OPTION_NAME_MAX_LENGTH = 100;
export const CUSTOM_FIELD_OPTION_DESCRIPTION_MAX_LENGTH = 500;
